import React, { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import AuthService from "../../services/auth.service";
import { removeToken } from "../../redux/tokenSlice";
import Loader from "../Loader";
import axios from "axios";
import { Box, ListItemIcon, Popover } from "@mui/material";
import { useDispatch } from "react-redux";

function AyekartAgroLimitBreachedGridView() {
  const location = useLocation();
  const userDetails = JSON.parse(localStorage.getItem("user_detail"));
  const [loading, setLoading] = useState(false);
  const [gridOrders, setGridOrders] = useState([]);
  const [markAsPaid, setMarkAsPaid] = useState(false);
  const [toGetUpdatedList, setTogetUpdatedList] = useState(false);
  const [status, setStatus] = useState("");
  const [allOrdersTotal, setAllOrdersTotal] = useState(0);
  const [selectAll, setSelectAll] = useState(false);
  const [dummy, setDummy] = useState(false);
  const [statusArray, setStatusArray] = useState([]);
  const [formObj, setFormObj] = useState([]);
  const [selectedOrdersTotal, setSelectedOrdersTotal] = useState(0);
  const [downloadSheetFlag, setDownloadSheetFlag] = useState(false);
  const [gridComment, setGridComment] = useState([]);
  const [gridStatus, setGridStatus] = useState("");
  const [currentGridId, setCurrentGridId] = useState(location?.state?.id);
  const [gridPage, setGridPage] = useState(location?.state?.gridPage || 1);
  const [totalGrids] = useState(location?.state?.totalGrids || 0);
  const [activeTab] = useState(location?.state?.activeTab ?? 0);
  const [searchQuery] = useState(location?.state?.searchQuery || "");

  const gridId = currentGridId ?? location?.state?.id;
  const tabNames = [
    "excep_pending",
    "excep_approved",
    "excep_plus_normal_approved",
    "excep_payment_done",
    "excep_cancelled",
  ];

  const history = useNavigate();

  const resetGridViewState = () => {
    setMarkAsPaid(false);
    setSelectAll(false);
    setSelectedOrdersTotal(0);
    setDownloadSheetFlag(false);
  };

  const getTableData = () => {
    if (!gridId) return;
    const token = localStorage.getItem("token");
    setLoading(true);
    setDownloadSheetFlag(false);
    fetch(`/workflow/api/${gridId}/orders`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => res.json())
      .then((res) => {
        if (res?.grid_status === "Paid") {
          setDownloadSheetFlag(true);
        }
        let temp = [];
        let sum = 0;
        res?.orders.map((item, index) => {
          if (item?.grid_status === "Paid") {
            setDownloadSheetFlag(true);
          }
          sum = sum + Number(item?.amount_to_be_paid_net_off_tds);
          temp.push({
            order_id: item?.order_id,
            order_flag: item?.grid_status === "Paid" ? true : false,
          });
        });
        setStatusArray(temp);
        setAllOrdersTotal(sum);
        setGridOrders(res?.orders);
        setGridComment(res?.grid_comment || "");
        setGridStatus(res?.grid_status);

        setStatus(res?.grid_status);
        if (res?.grid_status === "Paid") {
          setSelectedOrdersTotal(sum);
        }
        setLoading(false);
      });
  };

  const fetchGridAtPage = async (targetPage) => {
    if (targetPage < 1 || (totalGrids > 0 && targetPage > totalGrids)) return;

    setLoading(true);
    const token = localStorage.getItem("token");
    const selectedTab = tabNames[activeTab] || "excep_pending";

    try {
      const response = await fetch(
        `/workflow/api/orders/grids?is_exceptional_grid=true&org_id=1&tab_name=${selectedTab}&page=${targetPage}&limit=1${
          searchQuery ? `&id=${searchQuery}` : ""
        }`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const data = await response.json();

      if (data?.status && data?.grids?.length > 0) {
        const newGridId = data.grids[0].id;
        resetGridViewState();
        setCurrentGridId(newGridId);
        setGridPage(targetPage);
        history(location.pathname, {
          replace: true,
          state: {
            ...location.state,
            id: newGridId,
            gridPage: targetPage,
            activeTab,
            totalGrids,
            searchQuery,
          },
        });
      } else {
        toast.error("No grid found");
        setLoading(false);
      }
    } catch (error) {
      toast.error("Failed to fetch grid");
      setLoading(false);
    }
  };

  const handlePreviousGrid = () => {
    if (gridPage > 1) fetchGridAtPage(gridPage - 1);
  };

  const handleNextGrid = () => {
    if (totalGrids === 0 || gridPage < totalGrids) fetchGridAtPage(gridPage + 1);
  };

  useEffect(() => {
    getTableData();
  }, [toGetUpdatedList, currentGridId]);

  const submitMarkAsPaid = () => {
    let temp = statusArray;
    let tempArray = [];
    temp.map((item, index) => {
      if (item?.order_flag === true) {
        tempArray.push(item?.order_id);
      }
    });
    let finalTemp = [];
    gridOrders.map((item, index) => {
      if (tempArray.includes(item?.order_id)) {
        if (item?.grid_status !== "Paid") {
          finalTemp.push({
            id: item?.order_id,
            amount_paid: item?.total_cp,
            status: "Paid",
          });
        } else {
          finalTemp.push({
            id: item?.order_id,
            amount_paid: item?.total_cp,
            status: item?.grid_status,
          });
        }
      }
    });

    if (status === "Paid") {
      return toast.error("This grid has already added as Marked as Paid");
    }
    setLoading(true);
    const token = localStorage.getItem("token");
    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    const payload = {
      orders: finalTemp,
      grid_status:
        gridOrders?.length === tempArray?.length ? "Paid" : "Pending",
      actioner: userDetails?.user_name
        ? userDetails?.user_name
        : userDetails?.user_category,
    };
    axios
      .put(`/workflow/api/grid/${gridId}/paid`, payload, config)
      .then((data) => {
        if (!data?.data?.status) {
          setLoading(false);
          toast.error(data?.data?.message);
        } else {
          setTogetUpdatedList(true);
          toast.success(data?.data?.message);
          setTimeout(function () {
            history("/ayekart-fintech/grids", {
              state: { activeTab: 2 },
            });
          }, 1000);
        }
      });
  };

  const cancelGrid = () => {
    if (window.confirm("Do you really want to cancel this Grid?")) {
      setLoading(true);
      const token = localStorage.getItem("token");
      const config = {
        headers: { Authorization: `Bearer ${token}` },
      };
      const cancelGridOrders = gridOrders.map((item) => ({
        id: item?.order_id,
        amount_paid: item?.amount_paid,
        total_cp: item?.total_payable_net_off_tds,
      }));
      const payload = {
        orders: cancelGridOrders,
        grid_status: "Rejected",
        rejection_stamp: `${new Date()?.toISOString()}`,
        actioner: userDetails?.user_name
          ? userDetails?.user_name
          : userDetails?.user_category,
        actioner_id: userDetails?.id ? userDetails?.id : userDetails?.id,
      };
      axios
        .put(`/workflow/api/grid/${gridId}/paid`, payload, config)
        .then((data) => {
          if (!data?.data?.status) {
            setLoading(false);
            toast.error(data?.data?.message);
          } else {
            toast.success("Grid has been cancelled");
            setTimeout(function () {
              history("/ayekart-agro/limit-breached-grids", {
                state: { activeTab: 4 },
              });
            }, 1000);
          }
        });
    }
  };

  const getCSVForSBI = () => {
    // setLoading(true);
    // fetch(`/workflow/api/${location?.state}/finance?bank=sbi`)
    //   .then((res) => res.json())
    //   .then((res) => {
    //     setGridOrders(res?.orders);
    //     setLoading(false);
    //   });
    return toast.error("No records found to download...");
  };

  const getCSVForIcici = () => {
    setLoading(true);
    fetch(`/workflow/api/${gridId}/finance?bank=icici`)
      .then((res) => res.json())
      .then((res) => {
        setGridOrders(res?.orders);
        setLoading(false);
      });
  };

  const getCSVForAxis = () => {
    setLoading(true);
    fetch(`/workflow/api/${gridId}/finance?bank=sbi`)
      .then((res) => res.json())
      .then((res) => {
        setGridOrders(res?.orders);
        setLoading(false);
      });
  };

  console.log(location?.state?.activeTab);

  return (
    <div className="container-fluid">
      <Loader loading={loading} />
      <div className="p-3">
        <div className="row">
          <div className="col-2">
            <button
              className="btn btn-outline-primary"
              onClick={() =>
                history("/ayekart-agro/limit-breached-grids", {
                  state: { activeTab: location?.state?.activeTab },
                })
              }
            >
              <i className="fa fa-arrow-left me-2" aria-hidden="true"></i>
              Back to Grids
            </button>
          </div>
        </div>

        <div className="row mt-4 border p-3 rounded bg-white">
          <div className="col-12 col-md-12 pt-3">
            <h5 className="fw-bold">Total CP(₹)</h5>
            <h5>₹ {Number(allOrdersTotal).toFixed(2)}</h5>
          </div>

          <div className="col-4 pt-3">
            <div className="d-flex align-items-center gap-2 flex-wrap mb-3">
              <button
                type="button"
                className="btn btn-outline-primary btn-sm"
                onClick={handlePreviousGrid}
                disabled={gridPage <= 1 || loading}
              >
                Previous Grid
              </button>
              <h4 className="fw-semibold mb-0">Grid No. {gridId}</h4>
              <button
                type="button"
                className="btn btn-outline-primary btn-sm"
                onClick={handleNextGrid}
                disabled={
                  loading || (totalGrids > 0 && gridPage >= totalGrids)
                }
              >
                Next Grid
              </button>
              {totalGrids > 0 && (
                <span className="text-muted small">
                  ({gridPage} of {totalGrids})
                </span>
              )}
            </div>
          </div>

          <div className="col-8 pt-3">
            <div className="mb-3">
              <label className="form-label fw-bold">Grid Comment</label>
              <div className="p-2 border rounded bg-light">
                {gridComment || "Grid Comment Not Available"}
              </div>
            </div>
          </div>

          <div className="col-lg-12 col-md-12 px-0">
            <div className="table-responsive shadow rounded">
              <table className="table">
                <thead
                  className="position-sticky top-0"
                  style={{ backgroundColor: "#e2e8f0" }}
                >
                  <tr>
                    <th className="text-blue-900">Order ID</th>
                    <th className="text-blue-900">Supplier Shop Name</th>
                    <th className="text-blue-900">Total CP(₹)</th>
                    <th className="text-blue-900">Total Payable(₹)</th>
                    <th className="text-blue-900">TDS(₹)</th>
                    <th className="text-blue-900">Net Payable After TDS(₹)</th>
                  </tr>
                </thead>
                <tbody>
                  {gridOrders?.length > 0 ? (
                    gridOrders.map((item, index) => (
                      <tr key={index} className="">
                        <td>
                          <h6 className="mt-1">{item?.order_id}</h6>
                        </td>
                        <td>
                          <h6 className="mt-1">{item?.supplier_shop_name}</h6>
                        </td>
                        <td>
                          <input
                            className="form-control"
                            type="text"
                            readOnly
                            value={item?.total_payable_net_off_tds}
                          />
                        </td>
                        <td>
                          <input
                            className="form-control"
                            type="text"
                            readOnly
                            value={item?.total_payable}
                          />
                        </td>
                        <td>
                          <input
                            className="form-control"
                            type="text"
                            readOnly
                            value={item?.tds}
                          />
                        </td>
                        <td>
                          <h6 className="mt-1">
                            {item?.amount_to_be_paid_net_off_tds}
                          </h6>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center">
                        No Data Added
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {/* Cancel Grid */}
            {gridStatus !== "Rejected" && gridStatus !== "Paid" && (
              <button
                type="button"
                className="btn btn-danger px-3 mt-2"
                onClick={cancelGrid}
              >
                Cancel Grid
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AyekartAgroLimitBreachedGridView;
